import {useMemo, useState} from 'react'
import {Box, Flex, Table} from '@binance/uikit'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import useRouter from 'hooks/useRouter'
import useOrderHistoryDataProvider from 'hooks/useOrderHistoryDataProvider'
import useSymbolInfo from 'hooks/useSymbolInfo'
import {getDateRange} from 'utils/common'
import ToolBar from './ToolBar'
import {NoData} from './NoData'

const getTitles = i18n => [
  {
    title: i18n['tradeHistory-timeTitle'] || 'Time',
    key: 'insertTime',
    align: 'left',
    width: 158
  },
  {
    title: i18n['tradeHistory-symbolTitle'] || 'Symbol',
    key: 'symbol',
    align: 'left',
    width: 110
  },
  {
    title: i18n['tradeHistory-orderTypeTitle'] || 'Order Type',
    key: 'type',
    align: 'left',
    width: 110
  },
  {
    title: i18n['tradeHistory-sideTitle'] || 'Side',
    key: 'side',
    align: 'left',
    width: 110
  },
  {
    title: i18n.priceTitle || 'Price',
    key: 'price',
    align: 'right',
    width: 110
  },
  {
    title: i18n['tradeHistory-avgPriceTitle'] || 'Avg Price',
    key: 'avgPrice',
    align: 'right',
    width: 110
  },
  {
    title: i18n['tradeHistory-filledTitle'] || 'Filled',
    key: 'executedQty',
    align: 'right',
    width: 110
  },
  {
    title: i18n['tradeHistory-orderAmountTitle'] || 'Order Amount',
    key: 'origQty',
    align: 'right',
    width: 110
  },
  {
    title: i18n['tradeHistory-tiggerConditionTitle'] || 'Trigger Condition',
    key: 'stopPrice',
    align: 'right',
    width: 110
  },
  {
    title: i18n['tradeHistory-statusTitle'] || 'Status',
    key: 'status',
    align: 'right',
    width: 110
  }
]

export default function OrderHistoryPane ({i18n, focus}) {
  const router = useRouter()
  const {start, end} = getDateRange()
  const [startDate, setStartDate] = useState(start)
  const [endDate, setEndDate] = useState(end)
  const {symbol} = router.query
  const isLogin = useUserLoginStatus()
  const {symbolInfo} = useSymbolInfo()
  const {data = [], hasMore, loadMore} = useOrderHistoryDataProvider(
    isLogin,
    symbol,
    startDate,
    endDate,
    focus,
    symbolInfo
  )
  return useMemo(
    () =>
      isLogin ? (
        <Flex width="100%" flexDirection="column">
          <ToolBar
            i18n={i18n}
            activeColor="w"
            handleDateChange={({startTime, endTime}) => {
              setStartDate(startTime)
              setEndDate(endTime)
            }}
          />
          <Box flex={1}>
            <Table
              flex={1}
              data={data}
              title={getTitles(i18n)}
              nodata={isLogin ? NoData('order history') : null}
              hasMore={hasMore}
              loadMoreRows={loadMore}
            />
          </Box>
        </Flex>
      ) : null,
    [data, hasMore, i18n, isLogin, loadMore]
  )
}
